var _style, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThermometer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    style: {
      enableBackground: "new 0 0 46 46"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;fill-opacity:0.4;}\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:url(#SVGID_1_);fill-opacity:0.8;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M30.7,25.9V7.7C30.7,3.4,27.2,0,23,0s-7.7,3.4-7.7,7.7v18.3c-2.4,2.1-3.8,5.2-3.8,8.6C11.5,40.9,16.6,46,23,46 s11.5-5.1,11.5-11.5C34.5,31.1,33,28,30.7,25.9z M23,42.2c-4.2,0-7.7-3.4-7.7-7.7c0-2.2,0.9-4.3,2.6-5.7l1.3-1.1v-20 c0-2.1,1.7-3.8,3.8-3.8s3.8,1.7,3.8,3.8v20l1.3,1.1c1.6,1.4,2.6,3.5,2.6,5.7C30.7,38.7,27.2,42.2,23,42.2z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 23,
    y1: 30.7498,
    x2: 23,
    y2: 7.7498,
    gradientTransform: "matrix(1 0 0 -1 0 48)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFCE44"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7344,
    style: {
      stopColor: "#FF7B01"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#FF7B01"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M21.1,15.3h3.8v13.7c2.2,0.8,3.8,2.9,3.8,5.4c0,3.2-2.6,5.8-5.8,5.8s-5.8-2.6-5.8-5.8c0-2.5,1.6-4.6,3.8-5.4 V15.3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThermometer);
export default __webpack_public_path__ + "static/media/thermometer.fd78fd72c0184c9d7dba9cc8f6d368f4.svg";
export { ForwardRef as ReactComponent };